import axios from "axios";
import Cookies from "js-cookie";

export const getUserDetailsByToken = async () => {
  const token = Cookies.get("token");
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
   const headers = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
    Authorization: `Bearer ${token}`,
  };
  try {
    const userDetailsResponse = await axios.get(
      `${apiUrl}/merchant/get/merchant/details`,{
        headers: headers
      }
    );
    console.log({ userDetailsResponse });
    if (userDetailsResponse?.data?.success && userDetailsResponse?.status != 401) {
      return userDetailsResponse?.data?.details;
    } else {
      return {};
    }
  } catch (error) {
    console.log("Error : while fetching merchant details", error);
  }
};

export const GetWebAccessToken = async () => {
  try {
    const token = Cookies.get("token");
    const plToken = Cookies.get("plToken");
    console.log("token in GetWebAccessToken ===>>>", token);
    if (token) {
      return token;
    } else if (plToken) {
      return plToken;
    } else {
      return "";
    }
  } catch (error) {
    console.log("Error : while fetching GetWebAccessToken details", error);
  }
};

export const GetRegisteredMobileNumber = async () => {
  try {
    const mobileNumber = await Cookies.get("mobileNumber");
    if (mobileNumber) {
      return mobileNumber;
    }
    return "";
  } catch (error) {
    console.log("error==>", error);
  }
};
